export default "__VITE_ASSET__CCyXskfl__"